/* eslint-disable no-console */
const getContentHeight = (content) => {
  const innerDiv = content.querySelector('div:first-child');
  const height = innerDiv.offsetHeight;
  const paddingBottom = parseInt(window.getComputedStyle(innerDiv).paddingBottom, 10);
  return `${height - paddingBottom}px`;
};

const initContentToggle = () => {
  const expand = (btn) => {
    const ariaControls = btn.getAttribute('aria-controls');
    const content = document.getElementById(ariaControls);
    const openLabel = btn.getAttribute('data-openlabel');
    btn.setAttribute('aria-expanded', 'true');
    if (openLabel) {
      btn.innerHTML = openLabel;
    }
    content.classList.add('expand-content');
    content.style.height = getContentHeight(content);
  };

  const close = (btn) => {
    const ariaControls = btn.getAttribute('aria-controls');
    const closedLabel = btn.getAttribute('data-closedlabel');
    const content = document.getElementById(ariaControls);
    btn.setAttribute('aria-expanded', 'false');
    if (closedLabel) {
      btn.innerHTML = closedLabel;
    }
    content.classList.remove('expand-content');
    content.removeAttribute('style');
  };

  const toggleContent = (btn) => {
    const ariaExpanded = btn.getAttribute('aria-expanded');
    if (ariaExpanded === 'false') {
      expand(btn);
    } else {
      close(btn);
    }
  };

  const contentToggleBtns = document.querySelectorAll('.content-toggle-btn');
  [].map.call(contentToggleBtns, (btn) => {
    // If button's aria-expanded attr is set to true on page load...
    const ariaExpanded = btn.getAttribute('aria-expanded');
    if (ariaExpanded === 'true') {
      expand(btn);
    }
  });

  document.addEventListener('click', (event) => {
    const btn = event.target.closest('.content-toggle-btn');
    if (btn) {
      toggleContent(btn);
    }
  });

  if (contentToggleBtns.length > 0) {
    window.addEventListener('resize', () => {
      [].map.call(contentToggleBtns, (btn) => {
        // If button's aria-expanded attr is set to true on page load...
        const ariaExpanded = btn.getAttribute('aria-expanded');
        if (ariaExpanded === 'true') {
          const ariaControls = btn.getAttribute('aria-controls');
          const content = document.getElementById(ariaControls);
          content.style.height = getContentHeight(content);
        }
      });
    });
  }
};

const updateContentHeight = () => {
  const contentToggleBtns = document.querySelectorAll('.content-toggle-btn');
  [].map.call(contentToggleBtns, (btn) => {
    // If button's aria-expanded attr is set to true on page load...
    const ariaExpanded = btn.getAttribute('aria-expanded');
    if (ariaExpanded === 'true') {
      const ariaControls = btn.getAttribute('aria-controls');
      const content = document.getElementById(ariaControls);
      const openLabel = btn.getAttribute('data-openlabel');
      if (openLabel) {
        btn.innerHTML = openLabel;
      }
      content.classList.add('expand-content');
      content.style.height = getContentHeight(content);
    }
  });
};

export {
  initContentToggle,
  updateContentHeight,
};
/* eslint-enable no-console */
